import script from "./AudioComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioComp.vue?vue&type=script&setup=true&lang=ts"

import "./AudioComp.vue?vue&type=style&index=0&id=66a0b458&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a0b458"]])

export default __exports__